<template>
  <div>
    <div class="banner">和优秀的人，做有挑战的事</div>

    <div v-if="loading" class="loading">加载中...</div>
    <div v-else-if="error" class="error">{{ error }}</div>
    <div v-else class="product-detail">
      <div class="product-header">
        <h1>{{ product.name }}</h1>
        <button @click="goBack" class="back-button">返回产品列表</button>
      </div>
      <div class="product-content">
        <div class="product-image">
          <img :src="getFullImageUrl(product.image)"
          :alt="product.name" />
        </div>
        <div class="product-info">
          <h2>适用领域</h2>
          <p>{{ product.field }}</p>
          <h2>产品简介</h2>
          <p>{{ product.summary }}</p>
          <h2>详细描述</h2>
          <p class="multi-line-text">{{ product.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'; // 确保已安装并引入 axios
import { getProductById } from "@/api/product";
export default {
  name: 'ProductDetail',
  data() {
    return {
      product: null,
      loading: false,
      error: null
    };
  },
  created() {
    const productId = this.$route.params.id;
    if (productId) {
      this.fetchProductById(productId);
    } else {
      this.error = '未指定产品ID';
    }
  },
  methods: {
    async fetchProductById(id) {
      this.loading = true;
      this.error = null;

      try {
        const res = await getProductById(id);

        if (res.data.status === 200) {
          // ✅ 这里可以根据需要做映射，比如处理 image
          this.product = {
            ...res.data.data,
            image: res.data.data.image?.startsWith("http")
              ? res.data.data.image
              : this.$serverUrl + res.data.data.image
          };
        } else {
          this.error = res.data.msg || "获取产品失败";
        }
      } catch (err) {
        if (err.response) {
          this.error = `请求失败：${err.response.data.msg || "服务器错误"}`;
        } else if (err.request) {
          this.error = "网络连接失败，请检查网络";
        } else {
          this.error = `请求异常：${err.message}`;
        }
      } finally {
        this.loading = false;
      }
    },

        getFullImageUrl(imagePath) {
      return this.$serverUrl + imagePath;
    },
    goBack() {
      this.$router.push('/products');
    }
  }
};
</script>

<style scoped>
.banner {
  height: 200px;
  line-height: 200px;
  color: #fff;
  width: 100%;
  min-width: @main-width;
  background-image: url("../../assets/images/product.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: @font-size-larger;
}

.loading, .error {
  text-align: center;
  padding: 40px;
  font-size: 1.2em;
  color: #666;
}

.error {
  color: #d9534f;
}

.product-detail {
  padding: 20px;
  background-color: #f9f9f9;
  width: 70%;
  margin: auto;
  margin-top: 10px;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.back-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #0056b3;
}

.product-content {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.product-image {
  flex: 1;
  max-width: 300px;
}

.product-image img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.product-info {
  flex: 2;
}

.product-info h2 {
  font-size: 1.5em;
  margin-top: 0;
  color: #333;
}

.product-info p {
  margin-bottom: 15px;
  line-height: 1.6;
  color: #555;
}

@media (max-width: 768px) {
  .product-content {
    flex-direction: column;
    align-items: center;
  }

  .product-image {
    max-width: 100%;
  }

  .product-info {
    text-align: center;
  }
}

.multi-line-text {
  white-space: pre-wrap; /* 保留换行符和空白 */
}
</style>